import { NavLink } from "react-router-dom";
import { publicUrlFor } from "../../../globals/constants";

function Banner({ _data }) {
  return (
    <>
      <div
        className="full-landing-image sx-bnr-inr overlay-wraper  bg-top-center"
        style={{
          backgroundImage: `url(${publicUrlFor(_data.background)})`,
          backfaceVisibility: "hidden",
          backgroundBlendMode: "multiply",
          backgroundColor: "rgba(0, 0, 0, 0.19)",
        }}
      >
        <div className="overlay-main bg-white opacity-0" />
        <div className="container align-items-center d-flex">
          <div className="sx-bnr-inr-entry d-flex justify-content-center">
            <div className="banner-title-outer">
              <div className="banner-title-name">
                <h2 className="sx-title text-shadow-lg">{_data.title}</h2>
                <h6 className="pt-3 sx-bnr-1-large-title text-light">
                  Driving Digital Growth Through <br /> Smart IT Solutions
                </h6>
                {/* CTA */}
                <div className="sx-bnr-readmore mt-5">
                  <NavLink
                    to="/contact-us"
                    className="site-button sx-btn-primary icon"
                  >
                    Request A Call
                  </NavLink>
                </div>
              </div>
              {/* BREADCRUMB ROW */}
              {/* <div>
                                <ul className="sx-breadcrumb breadcrumb-style-2">
                                    <li><NavLink to="/">Home</NavLink></li>
                                    <li>{_data.crumb}</li>
                                </ul>
                            </div> */}
              {/* BREADCRUMB ROW END */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Banner;
